import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    zIndex: 100,
    position: 'relative',
    paddingTop: 5,
    cursor: 'pointer',
    height: '100%',
    flexWrap: 'nowrap',
    alignItems: 'flex-start'
  },
  labelHeader: {
    paddingLeft: 3,
    marginBottom: 3,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'normal'
  },
  icon: { marginRight: 6, fontSize: 18, color: theme.palette.grey[500] },
  title: {
    color: theme.palette.grey[500],
    fontWeight: 600
  },
  title2: {
    color: theme.palette.grey[800],
    fontWeight: 600
  },
  dateContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'normal',
    height: 40
  },
  dayContainer: {
    alignItems: 'center',
    height: '100%',
    display: 'flex',
    marginLeft: 12
  },
  monthContainer: {
    height: '100%',
    marginLeft: 8,
    display: 'flex',
    alignItems: 'center'
  },
  number: { fontWeight: 600 }
}))
export default useStyles
